import { render, staticRenderFns } from "./ICD10Section.vue?vue&type=template&id=3f99b77e"
import script from "./ICD10Section.vue?vue&type=script&lang=js"
export * from "./ICD10Section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports